export default {
  title: {
    generalConditions: "Conditions d'utilisation",
    legalMentions: 'Mentions légales',
    personalData: 'Données personnelles',
    privacyPolicy: 'Politique de confidentialité'
  }
}
